// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__G-gJ5","options":"AnswerScale_options__1dYE_","selected":"AnswerScale_selected__G-vVU"};